import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';
import { shouldReportErrorMonitor } from '../../Challenge/helpers/shouldReportErrorMonitor';
import { handleError } from '../../../ErrorHandler/errorHandlerPropsMap';
import { getInstance } from '../../../../services/instance';

export default async function (
  flowAPI: ControllerFlowAPI,
  personaId: string,
  programId: string,
): Promise<void> {
  const instanceFromUrl = getInstance(flowAPI);

  try {
    const pairs = (await flowAPI.httpClient.get(
      `/_api/online-programs-ai-helper-serverless/pair/query`,
      {
        params: {
          programId,
        },
        headers: {
          Authorization: instanceFromUrl,
        },
      },
    ))?.data as any;
    const pair = pairs?.items?.[0] || null;

    flowAPI.controllerConfig.setProps({
      currentChatPair: pair,
    });

    if (pair && (pair.disabled || !pair.synced)) {
      console.error('Chat was not initialised properly.');
    }
  } catch (error) {
    const resolvedError = flowAPI.errorHandler.getResolvedError(error);

    handleError({
      error,
      resolvedError,
      context: 'GetPersonaPair',
      preventErrorMonitorReport: !shouldReportErrorMonitor(error),
    });
  }
}
